<template>
  <div class="content flex-box">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-pass-check"
      entity-name="通行证"
      add-btn="添加"
      hide-show-detail
      :hide-action="!editable"
      :before-update="beforeUpdate"
      :before-edit="beforeEdit"
      :query="query"
      :action="action"
      :columns="columns"
      :rules="rules"
      :search-key-type="{type: 1}">
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.type" placeholder="输入通行证类型号查询"></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:edit="{form}">
        <a-form-model-item label="通行证类型" prop="type">
          <a-input v-model="form.type" placeholder="请输入通行证类型"></a-input>
        </a-form-model-item>
        <a-form-model-item label="有效期" prop="time">
          <a-range-picker
            v-model="form.time"
            :placeholder="['开始时间', '结束时间']"
            :show-time="{format: 'HH:mm'}"
            format="YYYY-MM-DD HH:mm"
            value-format="YYYY-MM-DD HH:mm"/>
        </a-form-model-item>
      </template>
    </data-list>
  </div>
</template>

<script>
    import {passColumns} from "../../../common/activity/vehicle";
    import mixins from "../mixins";

    export default {
        name: "ActivityPass",
        data() {
            return {
                columns: passColumns,
                rules: {
                    type: [{ required: true, message: '请输入通行证类型', trigger: 'blur' }],
                    time: [{ required: true, message: '请设置通行证有效期', trigger: 'blur' }]
                },
                moduleKey: 'traffic-pass',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        methods: {
            beforeEdit(form, fn) {
                if(form.valid_start_time && form.valid_end_time) {
                    form.time = [form.valid_start_time, form.valid_end_time];
                }
                fn();
            },
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                }
                form.valid_start_time = form.time[0];
                form.valid_end_time = form.time[1];
                fn();
            },
            importStaff() {
                this.visible = true;
            },
            confirmModal() {

            },
            handleFileSelect(e) {
                let file = e.target.files[0];
                this.file = file;
            },
            // 拖拽上传
            fileDragover (e) {
                e.preventDefault()
            },
            fileDrop (e) {
                e.preventDefault();
                const file = e.dataTransfer.files[0]; // 获取到第一个上传的文件对象
                this.file = file;
            },
        }
    }
</script>

<style scoped lang="less">
</style>
